import { useState } from 'react';
import { useT } from '../i18n.tsx';
import type { RoomApi } from '../net/useRoom.ts';
import { Spinner } from './common.tsx';
import { IconPlus } from './Icon.tsx';

/**
 * Mitspieler ohne eigenes Geraet direkt in der Spielerliste anlegen.
 *
 * Bewusst als letzte Zeile der Liste und nicht als eigener Abschnitt:
 * Die Zeile steht dort, wo der neue Spieler gleich auftaucht. Ein
 * separater Kasten daneben zwingt den Blick zum Springen und laesst die
 * beiden Wege ("am Handy beitreten" / "hier anlegen") getrennter
 * wirken, als sie sind.
 */
export function AddPlayerRow({ api }: { api: RoomApi }) {
  const t = useT();
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);

  const add = async () => {
    const trimmed = name.trim();
    if (trimmed.length === 0) return;

    setBusy(true);
    const result = await api.addLocalPlayer(trimmed);
    setBusy(false);
    if (result.ok) setName('');
  };

  return (
    <div className="add-player">
      <input
        className="add-player__input"
        maxLength={20}
        placeholder={t('local.namePlaceholder')}
        value={name}
        onChange={(event) => setName(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') void add();
        }}
        aria-label={t('local.add')}
      />
      <button
        type="button"
        className="btn btn--ghost"
        disabled={name.trim().length === 0 || busy}
        onClick={() => void add()}
      >
        {busy ? <Spinner /> : <IconPlus />}
        <span className="text-sm">{t('local.add')}</span>
      </button>
    </div>
  );
}
